import { useEffect, useContext } from 'react';
import { Key } from 'ts-key-enum';
import { AnalyticsContext } from '../../context/analyticsContext';

export default function useSearchDocumentKeyListener({
  isSearchOpen,
  setIsSearchOpen,
  searchInputValueRef,
  setSearchInputValue,
}) {
  const { analyticsClient } = useContext(AnalyticsContext);

  function handleDocumentKeyup({ key }) {
    if (!isSearchOpen) {
      return;
    }
    switch (key) {
      case Key.Escape:
        setIsSearchOpen(false);
        if (searchInputValueRef.current.trim().length) {
          setSearchInputValue('');
          analyticsClient?.clickSearchClear();
        }
        analyticsClient?.clickSearchClose();
        break;
    }
  }

  useEffect(() => {
    document.addEventListener('keyup', handleDocumentKeyup);
    return () => document.removeEventListener('keyup', handleDocumentKeyup);
  }, [isSearchOpen]);

  useEffect(() => {
    if (!isSearchOpen) {
      return;
    }

    function handleMousedown(e) {
      if (e.target.className.split(' ').includes('search-scrim')) {
        setIsSearchOpen(false);
        const searchInputValue = searchInputValueRef.current;
        if (searchInputValue.trim().length) {
          setSearchInputValue('');
          analyticsClient?.clickSearchClear();
        }
        analyticsClient?.clickSearchClose();
      }
    }

    document.addEventListener('mousedown', handleMousedown);
    return () => document.removeEventListener('mousedown', handleMousedown);
  }, [isSearchOpen]);
}
